import { Component, inject } from '@angular/core';
import { getUrlPathWithSuffix, pathNames, variablePathNames } from '../../utilities/routing-path-utils';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { UserService } from '../../services/user.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { NgClass, NgIf } from '@angular/common';
import { Observable, map, shareReplay } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-client-account-activation',
  standalone: true,
  imports: [
    MatProgressSpinnerModule,
    MatIconModule,
    NgClass,
    NgIf,
    RouterModule,
    MatButtonModule
  ],
  templateUrl: './client-account-activation.component.html',
  styleUrl: './client-account-activation.component.scss'
})
export class ClientAccountActivationComponent {
  isLoading: boolean = true;
  activationLink: string = '';
  private breakpointObserver = inject(BreakpointObserver);

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(
    private router: Router, 
    private route: ActivatedRoute, 
    private userService: UserService
  ){}

  ngOnInit(){
    this.validateClientAccount();
  }

  validateClientAccount(){
    this.getLinkId();

    this.userService.validateAccount(this.activationLink).subscribe({
      next: () => {
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        alert('Link already activated, expired or inexistant, login to claim another link');
        this.router.navigate([getUrlPathWithSuffix(pathNames.loginPath)]);
      }
    });
  }

  getLinkId(): string | null {
    this.route.paramMap.subscribe(params => {
      this.activationLink = params.get(variablePathNames.activationPathVariable) || '';
    });

    return this.activationLink;
  }

  onClickHereToLogin(){
    this.router.navigate([getUrlPathWithSuffix(pathNames.loginPath)]);
  }
}
